// Actions
import {
  SET_LIST_MEMBERSHIP,
  SET_NEW_LIST,
  SET_LIST_MEMBERSHIP_STATE
} from "../actionTypes/listMembership.actionTypes";

// Classes
import { ListMembershipReducerState } from "../classes/listMembership.classes";

const initialState = new ListMembershipReducerState();

export const ListMembershipReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_LIST_MEMBERSHIP:
      return { ...state, lists: action.payload };
    case SET_NEW_LIST:
      return { ...state, newList: action.payload };
    case SET_LIST_MEMBERSHIP_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
